import { z } from 'zod'

export const paramsSchema = z.object({
  destination: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
